import React__default from 'react';
import classnames from 'classnames';

const PackageQuantity = ({ 'data-t': dataT = 'package-quantity' , className , packageQuantities , item , dropdown ,  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: classnames([
            'contact-lens-configurator__package-quantity',
            className
        ]),
        "data-t": dataT
    }, packageQuantities.length === 1 ? item : dropdown)
;
var PackageQuantity$1 = PackageQuantity;

export { PackageQuantity$1 as default };
//# sourceMappingURL=PackageQuantity.js.map
